import React from 'react';
import CustomDocumentViewer from '../../../../../shared/custom-document-viewer/Custom-Document-Viewer';
import { parseObj } from '../../../../../utils/commonUtils';
import CustomView from '../../CustomView';
import './info-view.scss';

export const Details = ({ restaurantDetails }) => {
  let obj = restaurantDetails[3].doc;
  const { url, type, name } = parseObj(obj);
  return (
    <>
      {restaurantDetails.map((restroDetail) => (
        <CustomView
          key={restroDetail.id}
          type={restroDetail.type}
          value1={restroDetail.value1}
          value2={restroDetail.value2}
          name1={restroDetail.name1}
          name2={restroDetail.name2}
        />
      ))}
      <div className='row pt-5 mx-4'>
        <div className='col-md-6 '>
          <div className='details-label pb-2'>Menu</div>
          {restaurantDetails[6]?.menuStatus === 'Active' ? (
            <div>
              {restaurantDetails[7]?.ctaTitle !== '' && (
                <div>
                  <div className='cta-title pb-1'>CTA Title</div>
                  {restaurantDetails[7]?.ctaTitle}
                </div>
              )}

              {url && type ? (
                <CustomDocumentViewer
                  document={{ url: url, type: type }}
                  title={type === 'S3' ? (name ? name : 'Menu.pdf') : 'Menu url'}
                />
              ) : (
                <div>---</div>
              )}
            </div>
          ) : (
            <div>---</div>
          )}
          {restaurantDetails[6]?.menuStatus === 'Active' &&
            restaurantDetails[8]?.additionalMenu?.length > 0 && (
              <div className='mt-4'>
                <div className='details-label pb-2'>Additional Menu</div>
                {restaurantDetails[8].additionalMenu.map((item, index) => {
                  const parsed = typeof item.menu === 'string' && item.menu.includes('=') ? parseObj(item.menu) : null;
                  const menuUrl = parsed?.url || item.menu;
                  const menuType = parsed?.type || item.menuType;
                  const menuName = parsed?.name || (menuType === 'S3' ? 'Menu.pdf' : 'Menu url');
                  return (
                    <div key={index} className='mb-3'>
                      {item.ctaTitle && (
                        <div className='mb-1'>
                          <div className='cta-title pb-1'>CTA Title</div>
                          {item.ctaTitle}
                        </div>
                      )}
                      {menuUrl && menuType ? (
                        <CustomDocumentViewer
                          document={{ url: menuUrl, type: menuType }}
                          title={menuName}
                        />
                      ) : (
                        <div>---</div>
                      )}
                    </div>
                  );
                })}
              </div>
            )}
        </div>
        <div className='col-md-6'>
          <div className='details-label'>Status</div>
          <div
            className={`${
              restaurantDetails[5].status ? 'pill-active' : 'pill-inactive'
            } col-md-3 pill-text pill mt-3`}
          >
            <span>{restaurantDetails[5].status ? 'Active' : 'Inactive'}</span>
          </div>
        </div>
      </div>
      <div className='row mx-4 mt-4'>
        {restaurantDetails[4].customAttributes &&
          restaurantDetails[4].customAttributes.length > 0 &&
          restaurantDetails[4].customAttributes.map((item, index) => (
            <div key={index} className='col-md-6 mb-2'>
              <div className='details-label'>{item.key}</div>
              <div className='details-value'>{item.value}</div>
            </div>
          ))}
      </div>
    </>
  );
};
